export default {
    label_task:{
        en:"Parts",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New part",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit part",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of part",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}